/**
 * The Badge status each AIPVS (and AIPQS) tier wears, everywhere a tier is
 * shown: the lookup row, the pitch-list table and share page, the publisher
 * page and the earned-media breakdown. One map so a tier never reads as one
 * color in a table and another in its breakdown.
 *
 * Premium success, Strong info, Moderate warning, Limited error — the review
 * of the pitch-lists design (Sep 24, 2026) kept Limited on `error`.
 */
export type TierBadgeStatus = "success" | "info" | "warning" | "error";

export const TIER_STATUS: Record<number, TierBadgeStatus> = {
	1: "success",
	2: "info",
	3: "warning",
	4: "error",
};

/** The status for a tier, falling back to `info` for anything unexpected. */
export function tierBadgeStatus(
	tier: number | null | undefined,
): TierBadgeStatus {
	return (tier != null ? TIER_STATUS[tier] : undefined) ?? "info";
}
